/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Push_Rationale_EnableInputs */

const en_us2_push_rationale_enable = /** @type {(inputs: Push_Rationale_EnableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turn on`)
};

const pt_br2_push_rationale_enable = /** @type {(inputs: Push_Rationale_EnableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ativar`)
};

const es_419_push_rationale_enable = /** @type {(inputs: Push_Rationale_EnableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activar`)
};

const pt_pt2_push_rationale_enable = /** @type {(inputs: Push_Rationale_EnableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ativar`)
};

const fr_fr2_push_rationale_enable = /** @type {(inputs: Push_Rationale_EnableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activer`)
};

const de_de2_push_rationale_enable = /** @type {(inputs: Push_Rationale_EnableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einschalten`)
};

const it_it2_push_rationale_enable = /** @type {(inputs: Push_Rationale_EnableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attiva`)
};

/**
* | output |
* | --- |
* | "Turn on" |
*
* @param {Push_Rationale_EnableInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const push_rationale_enable = /** @type {((inputs?: Push_Rationale_EnableInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Rationale_EnableInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_push_rationale_enable(inputs)
	if (locale === "es-419") return es_419_push_rationale_enable(inputs)
	if (locale === "pt-PT") return pt_pt2_push_rationale_enable(inputs)
	if (locale === "fr-FR") return fr_fr2_push_rationale_enable(inputs)
	if (locale === "de-DE") return de_de2_push_rationale_enable(inputs)
	if (locale === "it-IT") return it_it2_push_rationale_enable(inputs)
	return en_us2_push_rationale_enable(inputs)
});
export { push_rationale_enable as "push.rationale_enable" }